export let moduleName = 'auth'

export let moduleObject = {
  namespaced: true,
  state: {
    token: null,
    isAuthenticated: {
      forMeterReading: false,
      forConsumption: false,
      forMrod: false,
      forUnsubscribe: false,
      forMonthOfStatement: false
    },
    isAmr: false,
    webRef: null,
    ean: null
  },
  getters: {
    isAuthenticated(state) {
      let auth = state.isAuthenticated
      return auth.forMeterReading || auth.forConsumption || auth.forMrod
    }
  },
  mutations: {
    authenticateMeterReading(state, token) {
      state.isAuthenticated.forMeterReading = true
      state.isAuthenticated.forConsumption = false
      state.isAuthenticated.forMrod = false
      state.isAuthenticated.forUnsubscribe = false
      state.isAuthenticated.forMonthOfStatement = false
      state.token = token
      state.isAmr = false
      const decodedToken = decodeTokenPayload(token)
      state.webRef = decodedToken.sub
      state.ean = decodedToken.ean_code
    },
    authenticateConsumption(state, token) {
      state.isAuthenticated.forMeterReading = false
      state.isAuthenticated.forConsumption = true
      state.isAuthenticated.forMrod = false
      state.isAuthenticated.forUnsubscribe = false
      state.isAuthenticated.forMonthOfStatement = false
      state.token = token
      const decodedToken = decodeTokenPayload(token)
      state.isAmr = JSON.parse(decodedToken.amr_meter)
      state.isMmr = JSON.parse(decodedToken.mmr_meter)
      state.isYmr = JSON.parse(decodedToken.ymr_meter)
    },
    authenticateAppointment(state, token) {
      state.isAuthenticated.forMeterReading = false
      state.isAuthenticated.forConsumption = false
      state.isAuthenticated.forMrod = true
      state.isAuthenticated.forUnsubscribe = false
      state.isAuthenticated.forMonthOfStatement = false
      state.token = token
      state.isAmr = false
    },
    authenticateUnsubscribe(state, token) {
      state.isAuthenticated.forMeterReading = false
      state.isAuthenticated.forConsumption = false
      state.isAuthenticated.forMrod = false
      state.isAuthenticated.forUnsubscribe = true
      state.isAuthenticated.forMonthOfStatement = false
      state.token = token
      state.isAmr = false
    },
    authenticateMonthOfStatement(state, token) {
      state.isAuthenticated.forMeterReading = false
      state.isAuthenticated.forConsumption = false
      state.isAuthenticated.forMrod = false
      state.isAuthenticated.forUnsubscribe = false
      state.isAuthenticated.forMonthOfStatement = true
      state.token = token
      state.isAmr = false
    },
    disconnect(state) {
      state.isAuthenticated.forMeterReading = false
      state.isAuthenticated.forConsumption = false
      state.isAuthenticated.forMrod = false
      state.isAuthenticated.forMonthOfStatement = false
      state.token = null
      state.isAmr = false
    }
  },
  actions: {}
}

function decodeTokenPayload(token) {
  return JSON.parse(atob(token.split('.')[1]))
}
